import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { Box, xcss } from '@atlaskit/primitives';

import { IconButton } from '@atlaskit/button/new';
import PersonAddIcon from '@atlaskit/icon/core/person-add';
import type { PresenceContentType } from '../presenceTypes';

type AddPersonProps = {
	contentType: PresenceContentType;
	toggleEmptyPresenceDialog: () => void;
};

const i18n = defineMessages({
	addPersonLabel: {
		id: 'team-presence.avatar-button.add-person-label',
		defaultMessage: 'Add Person to { contentType }',
		description: 'Accessible label for presence avatar add person button',
	},
	contentTypeLabel: {
		id: 'team-presence.avatar-button.content-type-label',
		defaultMessage:
			'{ contentType, select, page { page } blogpost { blog post } whiteboard { whiteboard} livepage { live doc } database { database } other { content } }',
		description: 'Label for content type in presence avatar add person button',
	},
});

const iconButtonStyles = xcss({
	marginLeft: 'space.negative.100',
});

export const AddPersonButton = ({ contentType, toggleEmptyPresenceDialog }: AddPersonProps) => {
	const { formatMessage } = useIntl();

	// TODO ENGAGEMENT-5503: update with suggested dialog
	const getPersonAddButtonOnClickHandler = () => {
		return toggleEmptyPresenceDialog;
	};

	const contentTypeLabel = formatMessage(i18n.contentTypeLabel, { contentType });

	return (
		<Box xcss={iconButtonStyles}>
			<IconButton
				shape="circle"
				label={formatMessage(i18n.addPersonLabel, { contentType: contentTypeLabel })}
				icon={PersonAddIcon}
				onClick={getPersonAddButtonOnClickHandler}
				testId={`team-presence-avatar-add-person-button`}
				// TODO ENGAGEMENT-5485: Add tooltip change and handle live page
			/>
		</Box>
	);
};
